 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import TOC from '@/components/toc'
 import A_CHAPTER1ONEDYNASTYTRANSFORMEDINTOAFEMALEEMPEROR from '@/components/0_chapter1onedynastytransformedintoafemaleemperor'
 import A_CHAPTER2STUMBLEAGAINSTTHEKING from '@/components/1_chapter2stumbleagainsttheking'
 import A_CHAPTER3THEELDERLINGSARECURIOUSTOINTERROGATETHEVASSALS from '@/components/2_chapter3theelderlingsarecurioustointerrogatethevassals'
 import A_CHAPTER4HEROSADBEAUTYPASS from '@/components/3_chapter4herosadbeautypass'
 import A_CHAPTER5FIFTEENCUPSOFSPRINGWATER from '@/components/4_chapter5fifteencupsofspringwater'
 import A_CHAPTER6THEQUEENOFTRAVELINGWITHTHEARMY from '@/components/5_chapter6thequeenoftravelingwiththearmy'
 import A_CHAPTER7SANDWOLFSHOWINGMYSTERIOUSLIFE from '@/components/6_chapter7sandwolfshowingmysteriouslife'
 import A_CHAPTER8SIRIUSINTHEHIGHMORAGE from '@/components/7_chapter8siriusinthehighmorage'
 import A_CHAPTER9HOWMANYGENERATIONSOFPREVIOUSLOVEDEBTHAVEBEENREPAID from '@/components/8_chapter9howmanygenerationsofpreviouslovedebthavebeenrepaid'
 import A_CHAPTER10SOLOVEISSOBROKEN from '@/components/9_chapter10soloveissobroken'
 import A0_CHAPTER11SOWHATIFHEDIEDLIKETHIS from '@/components/10_chapter11sowhatifhediedlikethis'
 import A1_CHAPTER12THEPASTISALONGSTORY from '@/components/11_chapter12thepastisalongstory'
 import A2_CHAPTER13THEPURPLESKYISSTILLCOMINGOUTBUTITSSTILLBREAKINGDOWN from '@/components/12_chapter13thepurpleskyisstillcomingoutbutitsstillbreakingdown'
 import A3_CHAPTER14ISTARTWITHTWOTHINGS from '@/components/13_chapter14istartwithtwothings'
 import A4_CHAPTER15MEETINGTHEKINGOFHELLINNANLUOTOWN from '@/components/14_chapter15meetingthekingofhellinnanluotown'
 import A5_CHAPTER16THREEMENFORAPLAY from '@/components/15_chapter16threemenforaplay'
 import A6_CHAPTER17MUTATIONINEVERYTHINGREGRETSINTESTINALREGRETS from '@/components/16_chapter17mutationineverythingregretsintestinalregrets'
 import A7_CHAPTER18ASTORMISBREWING from '@/components/17_chapter18astormisbrewing'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/toc",
 			"name" : "toc",
 			"component" : TOC
 		},
 		{
 			"path" : "/0_chapter1onedynastytransformedintoafemaleemperor",
 			"name" : "0_chapter1onedynastytransformedintoafemaleemperor",
 			"component" : A_CHAPTER1ONEDYNASTYTRANSFORMEDINTOAFEMALEEMPEROR
 		},
 		{
 			"path" : "/1_chapter2stumbleagainsttheking",
 			"name" : "1_chapter2stumbleagainsttheking",
 			"component" : A_CHAPTER2STUMBLEAGAINSTTHEKING
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js